module.exports = __webpack_public_path__ + "static/media/bg28.b950ff71.jpg";